<template>
  <div
    :dependentComputedProps="{
      isSessionPresent,
    }"
  >
    <div class="pb24 dt-mb64" v-if="bannerOffers.length">
      <div class="with-pagination">
        <Carousel
          :pauseAutoplayOnHover="true"
          :transition="500"
          :touchDrag="false"
          :mouseDrag="false"
          :settings="settings"
          :breakpoints="breakpoints"
        >
          <Slide
            class="dt-banner-wrap"
            :class="bannerOffers.length > 1 ? 'plr6' : 'full-width-card'"
            v-for="item in bannerOffers"
            :key="item?.id"
          >
            <div
              class="horizontal-carousel pr"
              :style="{
                background: item?.attributes?.backgroundGradient,
                width: '100vw',
              }"
            >
              <hero-banners
                :data-title="item.title"
                :data-subTitle="item.subTitle"
                :data-ctaText="item.attributes?.ctaText"
                :data-banner-img="item.logo"
                :data-img-bg="item.imgBig"
                :data-justify-img-content="item.attributes?.justifyImgContent"
                :data-title-color="item.attributes?.titleColor"
                :data-subTitle-color="item.attributes?.subTitleColor"
                :data-actionButton-color="item.attributes?.actionButtonColor"
                :data-actionButton-background="
                  item.attributes?.actionButtonBackground
                "
                :data-img-left="item.attributes?.imgPositionLeft"
                :data-img-width="item.attributes?.bannerImgWidth"
                :data-img-height="item.attributes?.bannerImgHeight"
                :data-text-align="item.attributes?.textAlign"
                :data-img-opacity="item.attributes?.imgOpacity"
                :data-banner-border-radius="item.attributes?.bannerImgRadius"
                :data-banner-img-style="
                  !item.imgBig ? 'herobanner-img-wrap' : 'herobanner-img-bg'
                "
                :data-action="item.mobileLinkRewrite"
                :data-coupon="item.couponCode"
              >
              </hero-banners>
            </div>
          </Slide>
          <!-- <template #addons v-if="clientPlatform == 'Web'">
            <Pagination />
          </template> -->
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { keyMapsAction } from "../helpers/storeKeys";
import { Carousel, Slide, Pagination } from "vue3-carousel";
import { clientPlatform } from "../config/apiEndpoints";

export default {
  name: "HorizontalCarousel",
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  props: ["moduleProps"],
  data() {
    return {
      clientPlatform,
      sessionDependedMethodsProcessed: false,
      settings: {
        itemsToShow: 1.3,
        autoplay: "1800",
        wrapAround: false,
      },
      modulePropsData: {},
      breakpoints: {
        300: {
          itemsToShow: 1.3,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
        700: {
          itemsToShow: 2,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
          autoplay: false,
          wrapAround: false,
        },
      },
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.breakpoints = {
      300: {
        itemsToShow: this.modulePropsData?.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: false,
      },
      700: {
        itemsToShow: this.modulePropsData?.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: false,
      },
      1024: {
        itemsToShow: this.modulePropsData?.itemsToShow,
        snapAlign: "start",
        autoplay: false,
        wrapAround: true,
      },
    };
  },
  computed: {
    bannerOffers() {
      return this.$store.state?.BannerOffers?.bannerOffers;
    },
    isSessionPresent() {
      let isSessionP = this.$store.state.Auth.isSessionPresent;
      if (isSessionP && !this.sessionDependedMethodsProcessed) {
        this.$store.dispatch(keyMapsAction.BANNER_OFFER_API, "Banner");
        this.sessionDependedMethodsProcessed = true;
      }
      return isSessionP;
    },
  },
};
</script>
